import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";

export default function PaymentSuccess() {
  const nav = useNavigate();
  const [status, setStatus] = useState("checking");
  const [kind, setKind] = useState("program");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }

    let attempts = 0;
    const poll = async () => {
      if (attempts >= 6) { setStatus("timeout"); return; }
      attempts += 1;
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        if (data.kind) setKind(data.kind);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 2000);
      }
    };
    poll();
  }, []);

  const messages = {
    checking: { t: "Confirming your payment…", s: "One moment while we verify with Stripe." },
    paid: kind === "store"
      ? { t: "Order confirmed. Reign on.", s: "Your Haus of Nata piece is being prepared. You'll get a shipping email within 3–5 business days." }
      : { t: "You're in. Welcome to the journey.", s: "Your program is now in your dashboard." },
    timeout: { t: "Still processing…", s: "Check your inbox shortly — we'll confirm once payment clears." },
    expired: { t: "Session expired", s: "Your checkout session expired. Please try again." },
    error: { t: "Something went wrong", s: "We couldn't find your session." },
  };
  const m = messages[status];

  return (
    <div className="min-h-screen bg-[#1E3A2B] flex items-center justify-center px-6 text-center" data-testid="payment-success">
      <div>
        <p className="eyebrow text-[#DCBB6C]">{kind === "store" ? "Haus of Nata" : "Overflow Academy"}</p>
        <h1 className={`font-serif-d text-4xl md:text-5xl text-[#FAF4E9] mt-4 ${status === "checking" ? "animate-pulse" : ""}`}>{m.t}</h1>
        <p className="text-[#FAF4E9]/70 mt-4">{m.s}</p>
        {status !== "checking" && (
          <button
            data-testid="payment-success-cta"
            onClick={() => nav(kind === "store" ? "/store" : "/dashboard")}
            className="mt-10 bg-[#C0953A] text-[#132619] hover:bg-[#DCBB6C] transition-colors px-8 py-4 uppercase tracking-widest text-xs font-semibold">
            {kind === "store" ? "Continue Shopping →" : "Go to Dashboard →"}
          </button>
        )}
      </div>
    </div>
  );
}
